import React from 'react';

import type { LaneMode } from '../../../apis/lanePlanner';
import { carrierInitials } from '../../../common/utils/providerLogo';
import styles from './styles.module.css';

const MODE_CLASS: Record<LaneMode, string> = {
  air: styles.carrierBadgeAir,
  ocean: styles.carrierBadgeOcean,
  road: styles.carrierBadgeRoad,
};

/** A carrier with no logo: its initials on the mode's colour. Renders nothing without a name. */
const CarrierBadge: React.FC<{
  name: string;
  mode: LaneMode;
  className?: string;
}> = ({ name, mode, className }) => {
  const initials = carrierInitials(name);
  if (!initials) return null;
  return (
    <span
      className={[styles.carrierBadge, MODE_CLASS[mode], className]
        .filter(Boolean)
        .join(' ')}
      title={name}
      aria-hidden
    >
      {initials}
    </span>
  );
};

export default CarrierBadge;
